import React from "react";
import { Button, Form, FormGroup, Label, Input, FormText, Col, Row, Alert } from 'reactstrap';

import authService from "services/auth.service";

import NotificationAlert from "react-notification-alert";





class AgentNewtkt extends React.Component {
  constructor(props) {

    let currentuser = authService.getCurrentUser().username

    super(props);
    this.state = {
      queue: this.props.defaultqueue === 'IT Service' ? 'HelpDesk' : this.props.defaultqueue,
      clients: [
        {
          "id": 1,
          "username": "test.user",
          "firstname": "testuser name",
          "lastname": "",
          "department": "Top Management"
        },
        {
          "id": 2,
          "username": "test.user1",
          "firstname": "",
          "lastname": "",
          "department": "Sales & Marketing"
        },
        {
          "id": 5,
          "username": "test.user2",
          "firstname": "",
          "lastname": "",
          "department": "Finance"
        },
        {
          "id": 6,
          "username": "test.user3",
          "firstname": "",
          "lastname": "",
          "department": "Sales"
        },
        {
          "id": 8,
          "username": "test.user4",
          "firstname": "",
          "lastname": "",
          "department": "Administration"
        },
        {
          "id": 9,
          "username": "test.user5",
          "firstname": "",
          "lastname": "",
          "department": "Warehouse"
        },
        {
          "id": 10,
          "username": "test.user6",
          "firstname": "",
          "lastname": "",
          "department": "Plant Admin"
        }
      ],
      client: "test.user",
      department: "Non-Updated",

      category: "",
      sub: "All",
      agent: "",
      author: 'test.user',
      state: "",
      formcatgs: [
        {
          "refsub": "Printer"
        },
        {
          "refsub": "Computer"
        },
        {
          "refsub": "iP-Phone"
        },
        {
          "refsub": "Office"
        },
        {
          "refsub": "Email"
        },
        {
          "refsub": "File"
        },
        {
          "refsub": "Applications"
        },
        {
          "refsub": "Network"
        },
        {
          "refsub": "iP-Cam"
        },
        {
          "refsub": "Purchase Request"
        },
        {
          "refsub": "SAP Reservation"
        },
        {
          "refsub": "Asset Management"
        },
        {
          "refsub": "Configuration Backup"
        },
        {
          "refsub": "Other"
        }
      ],
      prmqueue: '',
      formsubcats: ['All'],
      qusers: [
        {
          "refname": "test.agent1"
        },
        {
          "refname": "test.agent2"
        },
        {
          "refname": "test.agent3"
        },
        {
          "refname": "test.agent4"
        },
        {
          "refname": "test.agent5"
        },
        {
          "refname": "test.agent6"
        },
        {
          "refname": "test.agent7"
        },
        {
          "refname": "test.agent8"
        },
        {
          "refname": "test.agent9"
        },
        {
          "refname": "test.agent10"
        },
        {
          "refname": "test.agent11"
        }
      ],
      loading: false,
      description: '',
      fileData: ""


    };


  }



  notify = (typee, msg) => {
    var options = {};
    options = { place: 'tc', message: (<div><div> {msg}</div></div>), type: typee, icon: "now-ui-icons ui-1_bell-53", autoDismiss: 7, }
    this.refs.notificationAlert.notificationAlert(options);
  }






















  componentDidMount() {

  }

  componentWillUnmount() {



  }


  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.client.length < 1) { this.notify('danger', 'Please Select Client') }

    else if (this.state.category.length < 1) { this.notify('danger', 'Please Select Category') }
    else if (this.state.description.length < 10) { this.notify('danger', 'Description Field Must Be at Least 10 Characters') }

    else {

      this.setState({
        sub: '',
        description: '',
      });

      if (this.state.fileData.size > 1) {
        this.uploadFile(1)

        if (this.state.fileData.size > 1572864) {
          this.notify('info', 'Please Wait While Uploading');
        }

      }



      this.notify('info', 'Ticket Has Been Created');





    }



  }


  uploadFile = (tktid) => {

    let d = new Date();
    let month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    let date = d.getDate() + " " + month[d.getMonth()] + ", " + d.getFullYear();
    let time = d.toLocaleTimeString().toLowerCase();

    var hour = d.getHours();
    var min = d.getMinutes();
    var sec = d.getSeconds();

    if (this.state.fileData.size < 10485760) {

      const data = new FormData();
      var newFileName = `${date}-${hour}-${min}-${sec}-${this.state.fileData.name}`

      data.append("file", this.state.fileData, newFileName);

      console.log(this.state.fileData.size)

      this.setState({ loading: true })




      this.setState({ fileData: '', loading: false })

      setTimeout(() => { this.notify('info', 'File Has Been Uploaded'); }, 500);

    }

    else {
      this.notify('danger', 'Sorry! Maximum File Size is 10 MB, Please Choose another File');
    }



  };



  getFile = (e) => {

    if (e.target.files[0].size < 10485760) {


      this.setState({ fileData: e.target.files[0] })

    }

    else {

      this.setState({ fileData: '' })


      this.notify('danger', 'Sorry! Maximum File Size is 10 MB, Please Choose another File');

    }


  };









  handleChange = (e) => {


    let myPromise = new Promise((myResolve, myReject) => {

      // The producing code (this may take some time)
      this.setState({ [e.target.name]: e.target.value })




      myResolve(e.target.name);
      myReject("Error");





    });

    myPromise.then(
      (value) => {
        if (value === 'queue') {
          this.setState({ category: "", sub: "", agent: "" });;
        }

        if (value === 'category') { this.setState({ sub: "" }) }

      },
      (error) => { console.log(error); }
    );




    //handleChange = (e) =>{ this.setState({[e.target.name]: e.target.value})


  }

  render() {
    const categories = this.state.formcatgs.map(cat => <option key={cat.refsub}>{cat.refsub}</option>
    )


    const subcats = this.state.formsubcats.map(cat => <option key={cat.refname}>{cat.refname}</option>
    )

    const clients = this.state.clients.map(client => <option key={client.username}>{client.username}</option>
    )

    const qusrs = this.state.qusers.map(user => <option key={user.refname}>{user.refname}</option>
    )



    return (
      <div>
        <NotificationAlert ref="notificationAlert" />

        {this.state.loading ? <h1>Loading...</h1> :

          <Form autoComplete="off">

            <FormGroup >

              <Row >

                <Col>
                  <Label for="exampleSelect">Client</Label>

                  <br />


                  <input type="text" list="data" name="client" onChange={this.handleChange} value={this.state.client} className="form-control" required />

                  <datalist id="data">

                    {this.state.clients.map(client => <option key={client.id} value={client.username} />)}

                  </datalist>




                </Col>



              </Row>
              <br />


              <Row >





                <Col>
                  <Label for="exampleSelect">Queue</Label>
                  <Input type="select" name="queue" id="exampleSelect" onChange={this.handleChange} value={this.state.queue}>

                    <option>HelpDesk</option>
                    <option>System</option>
                    <option>Network</option>
                    <option>SAP</option>
                  </Input>
                </Col>

              </Row>

              <br />

              <Row>


                <Col>

                  <Label for="exampleSelect">Category</Label>
                  <Input type="select" name="category" id="catego" onChange={this.handleChange} value={this.state.category} required>

                    <option></option>
                    {categories}

                  </Input>
                </Col>


              </Row>
              <br />

              <Row>


                <Col>

                  <Label for="exampleSelect">Sub-Category</Label>
                  <Input type="select" name="sub" id="sub" onChange={this.handleChange} value={this.state.sub} required>
                    <option></option>
                    {subcats}
                  </Input>
                </Col>
              </Row>





              <br />
              <Row>
                <Col>
                  <Label for="exampleSelect">Assigned To</Label>
                  <Input type="select" name="agent" id="agent" onChange={this.handleChange} value={this.state.agent}>
                    <option></option>
                    {qusrs}
                  </Input>
                </Col>



              </Row>
              <br />



            </FormGroup>



            <Row>
              <Col xs={12} md={12}>

                <Label>Attachment </Label><span>( <strong> Optional</strong> Max 10 Megabytes)</span>
                <br /><br />
                <input type="file" name="file" onChange={this.getFile} />

                <br /><br />

              </Col>
            </Row>

            <FormGroup>

              <Label for="exampleText">Description</Label>
              <Input type="textarea" name="description" id="tktsss" onChange={this.handleChange} value={this.state.description} />
              <Button variant="primary" type="submit" onClick={this.handleSubmit} style={{ backgroundColor: 'rgb(101, 153, 57)' }} >
                Submit
              </Button>

            </FormGroup>
          </Form>
        }
      </div>
    )
  }
}



export default AgentNewtkt;